import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap-v5'
import SVG from 'react-inlinesvg'
import { IntroductionRequest } from '../../models';
import { handleImageErrorProfile } from '../../../../utils/UtilsFiles';
import { formatDateShortIntl2 } from '../../../../helpers/FormatDate';

type Props = {
    introduction?: IntroductionRequest;
    open: boolean;
    onCancel?: () => void;
    onLoad?: (isloaded:boolean) => void;
}

export const DetailModal: React.FC<Props> = ({ onCancel, onLoad, open, introduction }) => {
    useEffect(()=>{
    },[])

    const username = introduction?.relation === 'receiver' 
        ? introduction?.requester?.username 
        : introduction?.recipent?.username;

    const avatar = introduction?.relation === 'receiver'
        ? introduction?.requester?.avatar
        : introduction?.recipent?.avatar;

    return (
        <Modal 
            show={open} 
            centered 
            backdrop="static" 
            dialogClassName="introduction-detail-modal-dialog"
        >
            <div className="introduction-detail-modal">
                {/* CLOSE BUTTON */}
                <div className="introduction-detail-modal__close-btn" onClick={onCancel}>
                    <SVG src="/media/svg/nobilis/closeX.svg" />
                </div>

                {/* TITLE */}
                <div className="introduction-detail-modal__title">
                    Member Introduction
                </div>

                {/* USER INFO */}
                <div className="introduction-detail-modal__user">
                    <img 
                        src={avatar} 
                        alt={username} 
                        onError={handleImageErrorProfile} 
                    />
                    <span>{username || 'Member'}</span>
                </div>

                {/* CARD CONTAINER */}
                <div className="introduction-detail-modal__card">
                    {/* HEADER */}
                    <div className="introduction-detail-modal__header">
                        <div className="introduction-detail-modal__header-left">
                            <div className="introduction-detail-modal__header-label">Type</div>
                            <div className="introduction-detail-modal__header-value">
                                {introduction?.type || 'General Introduction'}
                            </div>
                        </div>
                        <div className="introduction-detail-modal__header-right">
                            <div className="introduction-detail-modal__header-date">
                                {formatDateShortIntl2(introduction?.dateRequest || '')}
                            </div>
                            {introduction?.dateExpires ? (
                                <div className="introduction-detail-modal__header-expiry">
                                    <SVG src="/media/svg/nobilis/clock.svg" />
                                    <span>{introduction?.dateExpires}</span>
                                    <SVG src="/media/svg/nobilis/info.svg" className="cursor-pointer" />
                                </div>
                            ) : (
                                <div className="introduction-detail-modal__header-expiry">
                                    <span>{introduction?.status}</span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* INFO BOX */}
                    <div className="introduction-detail-modal__info-box">
                        <div className="introduction-detail-modal__info-row">
                            <div className="introduction-detail-modal__info-label">
                                TOPIC
                            </div>
                            <div className="introduction-detail-modal__info-value">
                                {introduction?.topic || 'N/A'}
                            </div>
                        </div>
                        <div className="introduction-detail-modal__info-row">
                            <div className="introduction-detail-modal__info-label">
                                MESSAGE
                            </div>
                            <div className="introduction-detail-modal__info-value">
                                {introduction?.message || 'N/A'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

